import { Badge } from "@/components/ui/badge";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { api, formatApiError, formatCurrency } from "@/lib/api";
import { toast } from "@/components/ui/sonner";

const statuses = ["confirmed", "processing", "shipped", "delivered", "cancelled"];

export function OrderManager({ orders, onChanged }) {
  const updateStatus = async (order, order_status) => {
    try {
      await api.patch(`/admin/orders/${order.id}`, { order_status });
      toast.success("Order status updated");
      await onChanged();
    } catch (error) {
      toast.error(formatApiError(error));
    }
  };

  return (
    <section data-testid="admin-order-manager">
      <div className="mb-6 flex items-center justify-between">
        <h2 className="font-heading text-4xl font-black italic">Orders</h2>
        <Badge data-testid="orders-count-badge" className="rounded-none bg-neon text-black hover:bg-neon">{orders.length} total</Badge>
      </div>
      <div className="border border-white/10 bg-white/[0.02]">
        <Table>
          <TableHeader>
            <TableRow className="admin-table-row"><TableHead>Order</TableHead><TableHead>Customer</TableHead><TableHead>Items</TableHead><TableHead>Total</TableHead><TableHead>Status</TableHead></TableRow>
          </TableHeader>
          <TableBody>
            {orders.length === 0 ? (
              <TableRow><TableCell colSpan={5} className="py-12 text-center text-zinc-500" data-testid="no-orders-message">No orders yet.</TableCell></TableRow>
            ) : orders.map((order) => (
              <TableRow key={order.id} className="admin-table-row" data-testid={`admin-order-row-${order.id}`}>
                <TableCell><span className="font-bold text-volt">{order.order_number}</span><span className="block text-xs text-zinc-500">{new Date(order.created_at).toLocaleString()}</span></TableCell>
                <TableCell>{order.customer.name}<span className="block text-xs text-zinc-500">{order.customer.email}</span></TableCell>
                <TableCell>{order.items.map((item) => `${item.name} × ${item.quantity}`).join(", ")}</TableCell>
                <TableCell>{formatCurrency(order.total)}</TableCell>
                <TableCell>
                  <Select value={order.order_status} onValueChange={(value) => updateStatus(order, value)}>
                    <SelectTrigger data-testid={`order-status-${order.id}`} className="w-36 rounded-none bg-white/[0.03]"><SelectValue /></SelectTrigger>
                    <SelectContent className="bg-zinc-950 text-foreground">{statuses.map((status) => <SelectItem key={status} value={status}>{status}</SelectItem>)}</SelectContent>
                  </Select>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </section>
  );
}
